import { useMemo } from 'react'
import { calcNines } from './ggNines.js'
import { samplePlayers } from './ggSamplePlayers.js'

// G-Nines — isolated sandbox. 3-player game; uses the first three sample
// players. calcNines ported from GolfGamesScorecard (9 pts/hole: 5/3/1).
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }

export default function GNines() {
  const rows = useMemo(() => calcNines(samplePlayers().slice(0, 3)), [])
  return (
    <div className="card">
      <p className="text-sm text-gray-500 mb-3">Three players, 9 points per hole — outright low 5, second 3, third 1 (ties split 4/4/1 or 3/3/3).</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Pos', 'Player', 'Points'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{rows.map((p, i) => (
          <tr key={p.id}><td style={cell}>{i + 1}</td><td style={cell}>{p.name}</td><td style={cell}><b>{p.total}</b></td></tr>
        ))}</tbody>
      </table>
    </div>
  )
}
